var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{class:{
  'title': true,
  'font-weight-light': true,
  'text-left': !_vm.$vuetify.breakpoint.mdAndDown,
  'text-center': _vm.$vuetify.breakpoint.mdAndDown,
}},[_vm._l((_vm.links),function(link,index){return _c('v-col',{key:index,staticStyle:{"cursor":"pointer"},attrs:{"cols":"12"},on:{"click":function($event){return _vm.routeHandler(link.name)}}},[_vm._v(" "+_vm._s(link.text)+" ")])}),_c('v-col',{staticStyle:{"cursor":"pointer"},attrs:{"cols":"12"},on:{"click":_vm.downloadRules}},[_vm._v(" Политика конфиденциальности ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }